import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.showModal()
    console.log("Modal shown")

    this.element.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        event.preventDefault()
      }
    })
  }
}
